import './styles/Footer.css'

function Footer() {
  return (
    <div className='footer'>

<img src='https://pngimg.com/uploads/amazon/amazon_PNG11.png' alt='' className='footer__logo'/>

<p  className='footer__text'>
&copy; 2022 | Developed by <a href='github/vikash129' >Vikash Verma</a>
</p>

    </div>
  )
}

export default Footer